export enum FACILITY_SEARCH_MODE {
    SEARCH_BY_FLOOR = 'search_by_floor',
    SEARCH_BY_CATEGORY = 'search_by_category',
}
